import React, { useEffect, useState } from "react";
import { Convocatoria } from "../../models/ConvocatoriasModel/convocatoria.model";
import moment from "moment";
import { CalendarOutlined } from "@ant-design/icons";
import { ReactComponent as CalendarIcon } from "../../assets/calendar-detail.svg";
import ImageNotFound from "../../assets/enmascarar-detail.png";
import apiDocumentos from "../../api/Documentos/api-documentos";

interface IProps {
  convocatorias: Convocatoria;
  variant: "default" | "two";
}

export const FechasConvocatoriaBannerShared: React.FC<IProps> = (props: IProps) => {
  const [dataImg, setDataImg] = useState<any>();
  const [calculateDayStart, setCalculateDayStart] = useState<any>();
  const [calculateDayEnd, setCalculateDayEnd] = useState<any>();

  const getImageConvocatoria = async () => {
    if (props.convocatorias?.portada_url) {
      const data = await apiDocumentos.consultarArchivo(props.convocatorias?.portada_url);
      if (data?.data) {
        const reader = new FileReader();
        reader.readAsDataURL(data.data);
        reader.onloadend = function () {
          const base64String = reader.result;
          setDataImg(base64String);
        };
      }
    }
  };

  const calculateDate = (fechas: any) => {
    if (fechas !== null && fechas.length > 0) {
      const filterDateStart = fechas.filter((data: any) => data.clave === "Apertura");
      const filterDateEnd = fechas.filter((data: any) => data.clave === "Cierre");

      if (filterDateStart.length > 0) {
        setCalculateDayStart(moment(filterDateStart[0].valormin));
      }

      if (filterDateEnd.length > 0) {
        if (filterDateEnd[0].valormax && moment(filterDateEnd[0].valormax).isValid()) {
          setCalculateDayEnd(moment(filterDateEnd[0].valormax));
        } else {
          setCalculateDayEnd(moment(filterDateEnd[0].valormin));
        }
      }
    }
  };

  const getStatusConvocatoria = (convocatorias: any) => {
    if (!convocatorias.publico) {
      convocatorias.estado = "No publicada";
      return;
    }
    if (!convocatorias.fechas || convocatorias.fechas.length === 0) return;

    const fechaActual = moment();
    const calcFechaValida = (f: any) =>
      moment(f.valormax).isValid() ? moment(f.valormax) : moment(f.valormin);

    const apertura = convocatorias.fechas.find((f: any) => f.clave === "Apertura");
    if (apertura) {
      convocatorias.estado = fechaActual.isBefore(moment(apertura.valormin)) ? "En espera" : "Abierta";
    }

    const cierre = convocatorias.fechas.find((f: any) => f.clave === "Cierre");
    if (cierre && fechaActual.isSameOrAfter(calcFechaValida(cierre))) {
      convocatorias.estado = "Cerrada";
    }

    const resolucion = convocatorias.fechas.find((f: any) => f.clave === "Resolución de otorgamiento");
    if (resolucion && fechaActual.isSameOrAfter(calcFechaValida(resolucion))) {
      convocatorias.estado = "Cerrada";
    }
  };

  useEffect(() => {
    if (props.variant === "two") {
      calculateDate(props.convocatorias.fechas);
    }
    getStatusConvocatoria(props.convocatorias);
    getImageConvocatoria();
  }, [props.convocatorias]);

  if (props.variant === "two") {
    return (
      <div
        className="container-background-participantes-banner-two"
        style={{
          backgroundImage: dataImg ? `url(${dataImg})` : `url(${ImageNotFound})`,
          height: "500px",
          backgroundSize: "cover",
          backgroundAttachment: "fixed",
          boxShadow: "inset 0 0 0 2000px rgba(11, 165, 198, 0.7)",
        }}
      >
        <div className="subcontainer-background-participantes">
          <div className="container-fluid2 container-date-banner-two">
            <div className="row-container-date-banner">
              <div
                style={{ lineHeight: "normal", paddingBottom: "10px" }}
                className="col-12 container-detalle-card-body-semibold-work font-size-22px font-color-FFFFFF"
              >
                Fechas de la convocatoria
              </div>

              <div className="row align-items-center" style={{ maxWidth: "600px" }}>
                <div className="col-12 col-md-2 font-family-Montserrat-Regular font-size-10px font-color-FFFFFF ">
                  <p>
                    <CalendarIcon className="calendar-icon-banner-two" />
                  </p>
                </div>

                {props.convocatorias.fechas ? (
                  <>
                    <div className="col-6 col-md-3 font-family-Montserrat-Regular font-size-10px font-color-FFFFFF">
                      <span
                        className="no-margin container-detalle-card-body-bold"
                        style={{ fontSize: "18px" }}
                      >
                        <strong className="text-left container-detalle-card-body-bold">Inicia:</strong>
                      </span>{" "}
                      <div className="container-detalle-card-body-regular" style={{ fontSize: "18px" }}>
                        {moment(calculateDayStart).format("DD MMM / YYYY")}
                      </div>
                    </div>

                    <div className="col-6 col-md-7 font-family-Montserrat-Regular font-size-10px font-color-FFFFFF">
                      <span
                        className="no-margin container-detalle-card-body-bold"
                        style={{ fontSize: "18px" }}
                      >
                        <strong className="container-detalle-card-body-bold">Finaliza:</strong>
                      </span>{" "}
                      <div className="container-detalle-card-body-regular" style={{ fontSize: "18px" }}>
                        {moment(calculateDayEnd).format("DD MMM / YYYY")}
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="col-6 font-family-Montserrat-Regular font-size-10px font-color-FFFFFF">
                    <span
                      className="no-margin container-detalle-card-body-bold"
                      style={{ fontSize: "18px" }}
                    >
                      <strong className="text-left container-detalle-card-body-bold">
                        No hay fechas seleccionadas para esta convocatoria
                      </strong>
                    </span>{" "}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const formatFechaRango = (clave: string): string | null => {
    const fechas = props.convocatorias.fechas;
    if (!fechas || fechas.length === 0) return null;
    const matches = fechas.filter((data: any) => data.clave === clave);
    if (matches.length === 0) return null;
    const inicio = moment(matches[0].valormin.substring(0, 10)).format("ll");
    const maxMoment = moment(matches[0].valormax);
    const minMoment = moment(matches[0].valormin);
    const sufijo =
      maxMoment.isValid() && maxMoment.format("ll") !== minMoment.format("ll")
        ? ` al ${moment(matches[0].valormax.substring(0, 10)).format("ll")}`
        : "";
    return `${inicio}${sufijo}`;
  };

  const fechaInicio = formatFechaRango("Apertura");
  const fechaFin = formatFechaRango("Cierre");

  // Default variant
  return (
    <div
      className="container-background-participantes"
      style={{
        backgroundImage: dataImg ? `url(${dataImg})` : `url(${ImageNotFound})`,
        height: "500px",
        backgroundSize: "cover",
        backgroundAttachment: "fixed",
      }}
    >
      <div className="subcontainer-background-participantes">
        <div className="container-fluid2">
          <div className="row">
            <div className="col-12 col-md-9 mt-5 mb-5 px-5">
              <div className="row" style={{ width: "800px" }}>
                <div
                  style={{ lineHeight: "normal", paddingBottom: "2px" }}
                  className="col-12 font-family-Montserrat-Bold font-size-16px font-color-FFFFFF texto-sombras-general"
                >
                  Fechas de la convocatoria
                </div>

                <div className="d-flex align-items-center justify-content-center">
                  <div
                    className="col-6 col-md-3 font-family-Montserrat-Regular font-size-10px font-color-FFFFFF subtexto-sombras-general"
                    style={{ marginTop: "20px" }}
                  >
                    <p>
                      <CalendarOutlined style={{ fontSize: "40px" }} />
                    </p>
                  </div>

                  <div className="col-6 col-md-3 font-family-Montserrat-Regular font-size-10px font-color-FFFFFF subtexto-sombras-general">
                    <span
                      className="no-margin subtexto-sombras-general container-detalle-card-body-bold"
                      style={{ fontSize: "14px" }}
                    >
                      Inicia:
                    </span>{" "}
                    <div className="container-detalle-card-body-regular" style={{ fontSize: "14px" }}>
                      {fechaInicio}
                    </div>
                  </div>

                  <div className="col-6 font-family-Montserrat-Regular font-size-10px font-color-FFFFFF subtexto-sombras-general">
                    <span
                      className="no-margin container-detalle-card-body-bold"
                      style={{ fontSize: "14px" }}
                    >
                      Finaliza:
                    </span>{" "}
                    <div className="container-detalle-card-body-regular" style={{ fontSize: "14px" }}>
                      {fechaFin}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
